// extracted by mini-css-extract-plugin
module.exports =  {"tableContainer":"style-module_tableContainer__RtJHe9ueQWlYKMT5TGbD","sectionHeader":"style-module_sectionHeader__I2qcF05mt6xqpwQc6cHs"};